import React from 'react';
import { CTAButton } from './CTAButton';
const metrics = [{
  value: '10',
  label: 'Archivos PDF'
}, {
  value: '8',
  label: 'Bonos digitales'
}, {
  value: '97',
  label: 'Páginas visuales'
}, {
  value: '♾️',
  label: 'Acceso de por vida'
}];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-12 pt-10 sm:pb-20 sm:pt-16" data-id="element-159" data-mp="4lyvmmybwge6">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-160" data-mp="4jvvvb7dj8w9">
        <span className="mb-6 inline-block rounded-full border border-aura/50 bg-aura/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-aura" data-id="element-161" data-mp="128pijeo72z53">
          ✨ Sistema visual de autocuidado y bienestar · Edición 2026
        </span>

        <h1 className="font-serif-display text-[26px] font-bold leading-[1.15] text-plum sm:text-4xl md:text-[44px]" data-id="element-162" data-mp="ncq0pcba9kmr">
          Pasá de no saber qué hacer con lo que sentís a encontrar una práctica para acompañarte en
          pocos minutos
        </h1>

        <p className="mt-4 max-w-xl text-[13px] leading-relaxed text-plum/75 sm:text-base" data-id="element-163" data-mp="384jssxvrzhse">
          Aura Viva 2026 reúne prácticas breves, rituales y herramientas de autocuidado para
          ayudarte a reconocer lo que estás atravesando y comenzar con una acción concreta.
        </p>

        <p className="mt-4 font-serif-display text-base font-bold text-aura sm:text-xl" data-id="element-164" data-mp="39a35ovdc75ko">
          Abrís. Identificás. Elegís. Practicás.
        </p>

        <figure className="relative mt-8 w-full max-w-[680px] sm:mt-10" data-id="element-165" data-mp="30hhqfp8wzh0l">
          <div className="relative overflow-hidden rounded-[26px] bg-plum p-1.5 shadow-[0_26px_60px_-28px_rgba(52,36,60,0.55)] ring-1 ring-gold/25 sm:p-2" data-id="element-166" data-mp="30g6ozw2xylcn">
            <div className="relative overflow-hidden rounded-[20px]" data-id="element-167" data-mp="2ql68ojqk1yyr">
              <img src="https://cdn.magicpatterns.com/uploads/koiZPSe11TEJ7eJS1cxz4o/Aura-Viva-2027-mockup-principal.webp" alt="El sistema Aura Viva completo: la guía principal junto al planificador, el calendario lunar, el diccionario de cristales, el ritual de protección, las afirmaciones y el cuaderno de bienestar" width="1600" height="900" loading="eager" decoding="async" sizes="(max-width: 680px) calc(100vw - 40px), 680px" className="block aspect-[16/9] w-full object-cover" data-id="element-168" data-mp="2vies0nnfw91l" />
              <div className="pointer-events-none absolute inset-0 rounded-[20px] shadow-[inset_0_0_46px_16px_rgba(52,36,60,0.6)]" aria-hidden="true" data-id="element-169" data-mp="degcub9ei2ow" />
              <div className="pointer-events-none absolute inset-0 rounded-[20px] ring-1 ring-inset ring-gold/15" aria-hidden="true" data-id="element-170" data-mp="16345irwhbuch" />
            </div>
          </div>
          <figcaption className="px-3 pt-3 text-center text-xs font-medium text-plum/70" data-id="element-171" data-mp="x0uwk6gv0917">
            El sistema visual, organizado y listo para acompañarte cada vez que necesites volver a
            vos.
          </figcaption>
        </figure>

        <p className="mt-6 max-w-xl text-[12px] leading-relaxed text-plum/75 sm:text-base" data-id="element-172" data-mp="1x9kvmpllpais">
          No necesitás experiencia previa, conocimientos sobre energía ni rutinas difíciles de
          sostener.
        </p>

        <p className="mt-3 max-w-xl text-[12px] leading-relaxed text-plum/75 sm:text-base" data-id="element-173" data-mp="269r7y85kc4gd">
          Guía principal + documento “Empezá acá” + 8 bonos digitales. 97 páginas de prácticas,
          rituales y herramientas de autocuidado para comenzar a utilizar desde hoy.
        </p>

        <div className="mt-8 w-full max-w-md" data-id="element-174" data-mp="2kydt4qhvfqfi">
          <CTAButton label="QUIERO ACCEDER A AURA VIVA 2026" textClassName="text-[13px] tracking-tight sm:text-[16px] sm:tracking-normal" data-id="element-175" data-mp="2kx2gs2ad1acs" />
          <p className="mt-3 text-xs text-plum/70 sm:text-sm" data-id="element-176" data-mp="2tyin9yy20sbq">
            Acceso digital inmediato · Pago único · Sin suscripción
          </p>
          <p className="mt-2 text-xs font-medium leading-relaxed text-aura" data-id="element-177" data-mp="uou53fape6e2">
            La plataforma convierte automáticamente el precio a tu moneda local antes de confirmar
            la compra.
          </p>
        </div>

        <div className="mt-7 grid w-full grid-cols-2 overflow-hidden rounded-2xl border border-aura/20 bg-card sm:mt-9 sm:grid-cols-4" data-id="element-178" data-mp="3vi6x8hh604s3">
          {metrics.map((metric, index) => <div key={metric.label} className={`flex flex-col items-center px-3 py-5 sm:px-4 sm:py-6 ${index % 2 !== 0 ? 'border-l border-aura/15' : ''} ${index >= 2 ? 'border-t border-aura/15' : ''} sm:border-l sm:border-t-0 sm:first:border-l-0`} data-id="element-179" data-mp="9ah2n2i02jxn" data-mpi={index}>
              <span className="font-serif-display text-4xl font-bold leading-none text-aura" data-id="element-180" data-mp="3rgby9jmpi3hh">
                {metric.value}
              </span>
              <span className="mt-2 text-[11px] font-medium leading-snug text-plum sm:text-sm" data-id="element-181" data-mp="3mo2945tf17g9">
                {metric.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}